import { jsxs as F, jsx as e } from "react/jsx-runtime";
import { c as G } from "./index-65016bfa.mjs";
import { useState as a, useRef as K, useEffect as $ } from "react";
import x, { css as v } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as A } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Image as Q } from "./image.js";
import { PhotoGalleryThumbnail as c } from "./photoGalleryThumbnail.js";
import { PhotoGalleryLightbox as S } from "./photoGalleryLightbox.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "./childrenCountCheck-785fa19a.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./modalWindow.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useClient-0bbce34e.mjs";
import "./Aria-f5e019e2.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./disclosure.js";
import "./focusTrap.js";
import "./hTag-27bb1617.mjs";
import "./index-5d51183d.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./screenReaderOnly-fd82ed96.mjs";
import "./useWindowDimensions-ae69e913.mjs";
const U = x.div`
  &.PhotoGallery {
    ${({
  theme: {
    components: { photoGallery: s }
  }
}) => v({
  ...s.PhotoGalleryWrapper
})};
  }
`, B = x.div`
  &.PhotoGallery__thumbnail_item_wrapper {
    ${({
  theme: {
    components: { photoGallery: s }
  }
}) => v({
  ...s.PhotoGalleryThumbnailItemWrapper
})};
  }
`;
function Lt({
  galleryData: s,
  disableHoverZoom: I = !1,
  autoImageChange: _ = !1,
  imageInterval: j = 3e3,
  accessibilityOptions: D = {
    lightbox: {}
  },
  onImageClick: p,
  separator: R
}) {
  const W = A({ label: "Photo Gallery" }), [h, L] = a([]), [M, u] = a(!1), [O, T] = a(1), d = K({});
  $(() => {
    const o = w(s);
    L(o);
  }, [s]);
  const w = (o) => {
    let r = 1;
    return o.map((l) => ({
      size: l.size,
      images: l.images.map(
        (n) => n.map((t) => ({
          ...t,
          id: r++
        }))
      )
    }));
  }, f = ((o) => o.flatMap((r) => r.images.flatMap((l) => l)))(h), m = (o) => {
    T(o), u(!0);
  }, z = (o) => {
    u(!1);
    const r = d.current[o];
    r && setTimeout(() => {
      r.focus();
    }, 100);
  }, q = (o, r) => {
    (o.key === "Enter" || o.key === " ") && (o.preventDefault(), m(r), p == null || p());
  }, N = (o) => {
    p == null || p(), m(o);
  };
  return /* @__PURE__ */ F(
    U,
    {
      className: G(["PhotoGallery"]),
      ...W,
      children: [
        h.map((o, r) => /* @__PURE__ */ e(
          c,
          {
            size: o.size,
            disableHoverZoom: I,
            children: o.images.map((l, n) => /* @__PURE__ */ e(c.Wrapper, { children: l.map((t, E) => {
              var b, y, P;
              return /* @__PURE__ */ e(
                B,
                {
                  className: G(["PhotoGallery__thumbnail_item_wrapper"]),
                  tabIndex: 0,
                  role: "button",
                  ref: (i) => d.current[t == null ? void 0 : t.id] = i,
                  onClick: () => N(t == null ? void 0 : t.id),
                  onKeyDown: (i) => q(i, t == null ? void 0 : t.id),
                  children: /* @__PURE__ */ e(c.Item, { children: /* @__PURE__ */ e(
                    Q,
                    {
                      src: (t == null ? void 0 : t.thumbnail) || (t == null ? void 0 : t.src),
                      alt: t == null ? void 0 : t.alt,
                      objectFit: ((b = t == null ? void 0 : t.aspectRatioProp) == null ? void 0 : b.objectFit) || "cover",
                      variant: ((y = t == null ? void 0 : t.aspectRatioProp) == null ? void 0 : y.variant) || "none",
                      objectPosition: (P = t == null ? void 0 : t.aspectRatioProp) == null ? void 0 : P.objectPosition,
                      ratio: (t == null ? void 0 : t.ratio) || "16/9",
                      ...t,
                      id: void 0
                    }
                  ) })
                },
                E
              );
            }) }, n))
          },
          r
        )),
        f.length && /* @__PURE__ */ e(
          S,
          {
            images: f,
            onClose: z,
            isOpen: M,
            autoImageChange: _,
            imageInterval: j,
            activeIndex: O,
            accessibilityOptions: D.lightbox,
            separator: R
          }
        )
      ]
    }
  );
}
export {
  Lt as PhotoGallery
};
